import script from "./EditRoute.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditRoute.vue?vue&type=script&setup=true&lang=ts"

import "./EditRoute.vue?vue&type=style&index=0&id=29be46d5&lang=scss"

const __exports__ = script;

export default __exports__